/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

import { get } from '@/services/api/client';
import { ApiResponse } from '@/services/api/types';
import { SubscriptionLifecycleDto } from '@/types/superadmin.types';

const BASE_URL = '/admin/subscriptions';

export const subscriptionLifecycleService = {
  async getLifecycle(): Promise<SubscriptionLifecycleDto> {
    const response = await get<ApiResponse<SubscriptionLifecycleDto>>(`${BASE_URL}/lifecycle`);
    return response.data;
  },
};
